import ActRejectionRequest from "../../libs/core-api-requests/documents/ActRejectionRequest";
import { IActRejectionDTO, IActRejectionViewDTO } from "../../libs/coreapi-dto/documents/ActRejection";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";


export class ActRejectionDataProvider extends DictionaryDataProvider<IActRejectionViewDTO, IActRejectionDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<ActRejectionRequest> {
        return this._coreApiService.actRejectionRequest
    }   

    getView(body: IViewBody, callback?: (data: IActRejectionViewDTO[], totalCount: number) => void): void {
        this.getDataRequest()
            .then(r => r
                .getView(body, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data.entities, e.data.totalCount);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.title ?? 'ActRejectionDataProvider getView !isCompleted');
                })
            )
            .catch((e) => {
                throw new Error(e?.message.title ?? 'getView ActRejectionDataProvider !isCompleted')
            });
    }

    getItemById(idGlobal: string, body: IViewBody, callback?: (data: IActRejectionDTO[], totalCount: number) => void): void {
        this.getDataRequest()
            .then(r =>
                r.getItemById(idGlobal, body, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data.entities, e.data.totalCount);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e.message.detail);
                })
            )
            .catch((e) => {
                throw new Error(e?.message.title ?? 'getById ActRejectionDataProvider !isCompleted')
            });
    }

   
}